<div>
  <div style="margin-top:8px">
    <img src="/assets/pageImg/教師資料預覽頁面.jpg" style="width:100%" />
  </div>
  <br />
  <br />
  <br />
  <div style="min-height:600px;padding:30px;">
    <div>
      <div style="display: inline-block; max-width: 50%; vertical-align: top;margin-right:60px">
        <div>
          <img *ngIf="invite.picture2" src="{{globalVar.imgPath+invite.picture2}}" style="width:220px;border:1px solid #ddd;" />
          <img *ngIf="!invite.picture2" src="/assets/headImgs/1470140314_Add-Male-User.png" style="width: 220px; border: 1px solid #ddd; " />
        </div>
      </div>
      <div style="display: inline-block; max-width: 50%; vertical-align: top">
        <div style="font-weight:bold;font-size:large;color:#1e8086">
          教師基本資料
          <button (click)="deleteInvite()" mat-icon-button style="margin-left:50px;color:red">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <br />
        <div style="margin-bottom:8px">
          <span style="font-weight:bold">姓名：</span>
          <span>{{invite.name2}}</span>
        </div>
        <div style="margin-bottom:8px">
          <span style="font-weight:bold">姓別：</span>
          <span>{{invite.sex}}</span>
        </div>
        <div style="margin-bottom:8px">
          <span style="font-weight:bold">生日：</span>
          <span>{{invite.birthday}}</span>
        </div>
        <div style="margin-bottom:8px">
          <span style="font-weight:bold">電子信箱：</span>
          <a href="mailto:{{invite.email}}">{{invite.email}}</a>
        </div>
        <div style="margin-bottom:8px">
          <span style="font-weight:bold">連絡電話：</span>
          <span>{{invite.phone}}</span>
        </div>
        <div style="margin-bottom:8px">
          <span style="font-weight:bold">地址：</span>
          <span>{{invite.address}}</span>
        </div>
        <br />
      </div>
    </div>
    <br />
    <div style="font-weight:bold;font-size:large;color:#1e8086">
      履歷資料
    </div>
    <div style="margin-top:10px;white-space:pre-line;word-break:break-all;line-height: 25px">
      {{invite.resume}}
    </div>
    <br />
    <br />
    <div style="font-weight:bold;font-size:large;color:#1e8086">
      專長科目
    </div>
    <div style="margin-top:10px;white-space:pre-line;word-break:break-all;line-height: 25px">
      {{invite.expertise}}
    </div>
    <br />
    <br />
    <div style="font-weight:bold;font-size:large;color:#1e8086">
      教師學歷
    </div>
    <div style="margin-top:10px;white-space:pre-line;word-break:break-all;">
      <div style="margin-bottom:8px">
        <span style="font-weight:bold">高中-科系　：</span>
        <span>{{invite.highSchool}}</span>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <mat-checkbox disabled [(ngModel)]="invite.isDone1">是否畢業</mat-checkbox>
      </div>
      <div style="margin-bottom:8px">
        <span style="font-weight:bold">大學-科系　：</span>
        <span>{{invite.university}}</span>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <mat-checkbox disabled [(ngModel)]="invite.isDone2">是否畢業</mat-checkbox>
      </div>
      <div style="margin-bottom:8px">
        <span style="font-weight:bold">研究所-科系：</span>
        <span>{{invite.graduateSchool}}</span>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <mat-checkbox disabled [(ngModel)]="invite.isDone3">是否畢業</mat-checkbox>
      </div>
    </div>
    <br />
    <br />
    <div style="font-weight:bold;font-size:large;color:#1e8086">
      期望鐘點費
    </div>
    <div style="margin-top:10px;white-space:pre-line;word-break:break-all;line-height: 25px">
      <span>新台幣：</span>
      <span style="font-weight:bold">{{invite.price1}}~{{invite.price2}}</span>
      <span>／小時</span>
    </div>
    <br />
    <br />
    <div style="font-weight:bold;font-size:large;color:#1e8086">
      服務方式
    </div>
    <div style="margin-top:10px;white-space:pre-line;word-break:break-all;">
      <mat-checkbox style="margin-bottom: 8px; display: block" disabled [(ngModel)]="c1"><span style="color: #000">線上教學</span> </mat-checkbox>
      <mat-checkbox style="margin-bottom: 8px; display: block" disabled [(ngModel)]="c2"><span style="color: #000">到府教學。服務區域：<input [(ngModel)]="invite.c2" style="border:0;border-bottom:1px solid #333;width:300px" disabled /></span></mat-checkbox>
      <mat-checkbox style="margin-bottom: 8px; display: block" disabled [(ngModel)]="c3"><span style="color: #000">指定地點教學。服務區域：<input [(ngModel)]="invite.c3" style="border:0;border-bottom:1px solid #333;width:300px" disabled /></span></mat-checkbox>
      <mat-checkbox style="margin-bottom: 8px; display: block" disabled [(ngModel)]="c4"><span style="color: #000">補習班教學。服務區域：<input [(ngModel)]="invite.c4" style="border:0;border-bottom:1px solid #333;width:300px" disabled /></span></mat-checkbox>
    </div>
    <br />
    <br />
    <div style="font-weight:bold;font-size:large;color:#1e8086">
      上課方式
    </div>
    <div style="margin-top:10px;white-space:pre-line;word-break:break-all;">
      <mat-checkbox style="margin-bottom: 8px; display: block" disabled [(ngModel)]="d1"><span style="color: #000">一對一上課</span> </mat-checkbox>
      <mat-checkbox style="margin-bottom: 8px; display: block" disabled [(ngModel)]="d2"><span style="color: #000">小型一對多上課</span></mat-checkbox>
      <mat-checkbox style="margin-bottom: 8px; display: block" disabled [(ngModel)]="d3"><span style="color: #000">大型團班授課</span></mat-checkbox>
      <mat-checkbox style="margin-bottom: 8px; display: block" disabled [(ngModel)]="d4"><span style="color: #000">錄影上架販售</span></mat-checkbox>
    </div>
    <br />
    <br />
    <div style="font-weight:bold;font-size:large;color:#1e8086">
      教材
    </div>
    <div style="margin-top:10px;white-space:pre-line;word-break:break-all;">
      <mat-checkbox style="margin-bottom: 8px; display: block" disabled [(ngModel)]="e1"><span style="color: #000">已有自編教材</span> </mat-checkbox>
      <mat-checkbox style="margin-bottom: 8px; display: block" disabled [(ngModel)]="e2"><span style="color: #000">計畫編製自用教材</span></mat-checkbox>
      <mat-checkbox style="margin-bottom: 8px; display: block" disabled [(ngModel)]="e3"><span style="color: #000">外購</span></mat-checkbox>
    </div>
    <br />
    <br />
    <div style="font-weight:bold;font-size:large;color:#1e8086">
      書寫工具
    </div>
    <div style="margin-top:10px;white-space:pre-line;word-break:break-all;">
      <mat-checkbox style="margin-bottom: 8px; display: block" disabled [(ngModel)]="a1"><span style="color: #000">專用電繪板與電繪筆（二者須同時具備，方能勾選）</span> </mat-checkbox>
      <mat-checkbox style="margin-bottom: 8px; display: block" disabled [(ngModel)]="a2"><span style="color: #000">無電繪板、電繪筆，但經錄取後院自行購買相關配置</span></mat-checkbox>
      <mat-checkbox style="margin-bottom: 8px; display: block" disabled [(ngModel)]="a3"><span style="color: #000">專教文科，鍵盤輸入夠快，可不用電繪板。</span></mat-checkbox>
      <mat-checkbox style="margin-bottom: 8px; display: block" disabled [(ngModel)]="a4"><span style="color: #000">其他：<input [(ngModel)]="invite.other" style="border:0;border-bottom:1px solid #333;width:300px" disabled /></span></mat-checkbox>
    </div>
    <br />
    <br />
    <div style="font-weight:bold;font-size:large;color:#1e8086">
      視訊設備
    </div>
    <div style="margin-top:10px;white-space:pre-line;word-break:break-all;">
      <mat-checkbox style="margin-bottom: 8px; display: block" disabled [(ngModel)]="b1"><span style="color: #000">耳機</span></mat-checkbox>
      <mat-checkbox style="margin-bottom: 8px; display: block" disabled [(ngModel)]="b2"><span style="color: #000">麥克風</span></mat-checkbox>
      <mat-checkbox style="margin-bottom: 8px; display: block" disabled [(ngModel)]="b3"><span style="color: #000">耳機麥克風（耳麥）</span></mat-checkbox>
      <mat-checkbox style="margin-bottom: 8px; display: block" disabled [(ngModel)]="b4"><span style="color: #000">音響喇叭</span></mat-checkbox>
      <mat-checkbox style="margin-bottom: 8px; display: block" disabled [(ngModel)]="b5"><span style="color: #000">視訊鏡頭</span></mat-checkbox>
    </div>
    <br />
    <br />
    <div style="font-weight:bold;font-size:large;color:#1e8086">
      可授課時間
    </div>
    <div style="margin-top:10px;white-space:pre-line;word-break:break-all;">
      <div style="margin-bottom:8px">
        <span style="font-weight:bold">星期日：</span>
        <span *ngFor="let item of timeOptionList">
          <span style="display:inline-block;width:50px" *ngIf="item.id.substring(0,1) == '0' && item.click">{{item.value}}</span>
        </span>
      </div>
      <div style="margin-bottom:8px">
        <span style="font-weight:bold">星期一：</span>
        <span *ngFor="let item of timeOptionList">
          <span style="display:inline-block;width:50px" *ngIf="item.id.substring(0,1) == '1' && item.click">{{item.value}}</span>
        </span>
      </div>
      <div style="margin-bottom:8px">
        <span style="font-weight:bold">星期二：</span>
        <span *ngFor="let item of timeOptionList">
          <span style="display:inline-block;width:50px" *ngIf="item.id.substring(0,1) == '2' && item.click">{{item.value}}</span>
        </span>
      </div>
      <div style="margin-bottom:8px">
        <span style="font-weight:bold">星期三：</span>
        <span *ngFor="let item of timeOptionList">
          <span style="display:inline-block;width:50px" *ngIf="item.id.substring(0,1) == '3' && item.click">{{item.value}}</span>
        </span>
      </div>
      <div style="margin-bottom:8px">
        <span style="font-weight:bold">星期四：</span>
        <span *ngFor="let item of timeOptionList">
          <span style="display:inline-block;width:50px" *ngIf="item.id.substring(0,1) == '4' && item.click">{{item.value}}</span>
        </span>
      </div>
      <div style="margin-bottom:8px">
        <span style="font-weight:bold">星期五：</span>
        <span *ngFor="let item of timeOptionList">
          <span style="display:inline-block;width:50px" *ngIf="item.id.substring(0,1) == '5' && item.click">{{item.value}}</span>
        </span>
      </div>
      <div style="margin-bottom:8px">
        <span style="font-weight:bold">星期六：</span>
        <span *ngFor="let item of timeOptionList">
          <span style="display:inline-block;width:50px" *ngIf="item.id.substring(0,1) == '6' && item.click">{{item.value}}</span>
        </span>
      </div>
    </div>
    <br />
    <br />
    <div style="font-weight:bold;font-size:large;color:#1e8086">
      備註
    </div>
    <div style="margin-top:10px;white-space:pre-line;word-break:break-all;line-height: 25px">
      {{invite.memo}}
    </div>
    <br />
    <br />
    <div style="width:100%;word-break:break-all">
      <div style="display:inline-block;width:30px;vertical-align:top">
        <mat-checkbox disabled [(ngModel)]="invite.isAgree"></mat-checkbox>
      </div>      
      <div style="display: inline-block; width: calc(100% - 30px); font-size: large; font-weight: bold; color: red">
        未經無敵雲數位資源整合平台之同意，本人承諾不以任何形式私自接洽無敵雲派發任課學生，亦不得以任何名義對上述學員招攬文理升學課程。若否，造成侵權行為，願負一切責任。
      </div>
    </div>
    <br />
  </div>
</div>

